/**
 * Scroll reveals.
 *
 * Sets `data-motion-ready` on the root element, which is what arms the CSS
 * "from" state in components.css. Until this module runs, and if it never
 * runs, every revealed element renders in its final visible state.
 */
import { revealOnScroll, prefersReducedMotion } from 'theme:motion';

if (!prefersReducedMotion()) {
  document.documentElement.setAttribute('data-motion-ready', '');

  revealOnScroll('[data-reveal]', { y: 28 });
  revealOnScroll('[data-reveal-group]', { y: 20, stagger: 0.06 });
}
